export const nonAccountNumberCharacters = new RegExp(/[^A-Z0-9\s.,:-]+/g);

export function clean(subject: string) {
  return subject
    .toUpperCase()
    .replace(nonAccountNumberCharacters, ``)
  ;
}
